import { Menu as MuiMenu, MenuItem as MuiMenuItem } from "@mui/material";
import { first, isEmpty } from "lodash";
import { PropTypes } from "prop-types";

const Menu = ({ id, className, anchorEl, position, onClose, children, ...restProps }) => (
  <MuiMenu
    id={id}
    anchorEl={anchorEl}
    onClose={onClose}
    MenuListProps={{ className }}
    open
    {...(isEmpty(position) ? {} : { anchorOrigin: first(position), transformOrigin: position[1] })}
    {...restProps}
  >
    {children}
  </MuiMenu>
);

Menu.MenuItem = MuiMenuItem;

Menu.defaultProps = {
  id: null,
  className: null,
  position: [],
};

Menu.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  anchorEl: PropTypes.instanceOf(Element).isRequired,
  onClose: PropTypes.func.isRequired,
  position: PropTypes.arrayOf(PropTypes.shape({ vertical: PropTypes.string, horizontal: PropTypes.string })),
  children: PropTypes.node.isRequired,
};

export default Menu;
